import { createSelector } from 'reselect';
import {
    getLoadingStatuses,
    getAllAssets
} from 'helpers/selectors';
import { getSelectedNotification } from '../../PowertrainOverview/Header/NotificationDropdown/selectors';
import { getAssetOverviewList as getconditionIndicesV2AssetList } from './AssetOverview/selectors';
import { getPowertrainOverviewList } from './PowertrainOverview/selectors';
import { getAssetGroupOverviewList } from './AssetGroupOverview/selectors';


const getAssetNumber = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.assets?.count;
};

const getAssetGroupNumber = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.assetGroups?.count;
};

const getAssetGroupAssetNumber = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.assetGroups?.assetCount;
};

const getPowertrainNumber = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.powertrains?.count;
};

const getPowertrainAssetNumber = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.powertrains?.assetCount;
};

const getAssetOverviewLoadingStatus = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.assets?.loadingStatus;
};

const getAssetGroupOverviewLoadingStatus = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.assetGroups?.loadingStatus;
};

const getPowertrainOverviewLoadingStatus = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.powertrains?.loadingStatus;
};

const getConditionFilter = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.filter?.conditionFilter;
};

const getAssetsAssetTypeFilter = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.filter?.assets?.assetTypeFilter;
};

const getAssetGroupsAssetTypeFilter = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.filter?.assetGroups?.assetTypeFilter;
};

const getPowertrainsAssetTypeFilter = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.filter?.powertrains?.assetTypeFilter;
};

const getHierarchyAssetTypeFilter = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.filter?.hierarchy?.assetTypeFilter;
};

const getAssetsSubscriptionTypeFilter = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.filter?.assets?.subscriptionTypeFilter;
};

const getAssetGroupsSubscriptionTypeFilter = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.filter?.assetGroups?.subscriptionTypeFilter;
};

const getPowertrainsSubscriptionTypeFilter = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.filter?.powertrains?.subscriptionTypeFilter;
};

const getHierarchySubscriptionTypeFilter = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.filter?.hierarchy?.subscriptionTypeFilter;
};

const getSubscriptiontypes = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.subscriptionTypes?.data;
};

const getActiveTab = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.selectedTab;
};

const getAssetsSearchBoxFilter = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.filter?.assets?.searchBox;
};

const getAssetGroupsSearchBoxFilter = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.filter?.assetGroups?.searchBox;
};

const getPowertrainsSearchBoxFilter = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.filter?.powertrains?.searchBox;
};

const getHierarchySearchBoxFilter = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.filter?.hierarchy?.searchBox;
};

const getAssetsSensorIdentifierFilter = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.filter?.assets?.sensorIdentifierFilter;
};

const getAssetGroupsSensorIdentifierFilter = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.filter?.assetGroups?.sensorIdentifierFilter;
};

const getPowertrainsSensorIdentifierFilter = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.filter?.powertrains?.sensorIdentifierFilter;
};

const getHierarchySensorIdentifierFilter = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.filter?.hierarchy?.sensorIdentifierFilter;
};

const getFilterInProgress = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.isFilterInProgress;
};

const getSelectedFilters = ({ generalFilter }) => {
    return generalFilter?.selectedFilters;
};

const getSelectedOrganization = ({ generalFilter }) => {
    return generalFilter?.selectedFilters?.organizations[0];
};

const getSelectedAsset = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.selectedAsset;
};

const getAssetsConditionFilter = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.filter?.assets?.conditionFilter;
};

const getAssetGroupsConditionFilter = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.filter?.assetGroups?.conditionFilter;
};

const getPowertrainsConditionFilter = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.filter?.powertrains?.conditionFilter;
};

const getHierarchyConditionFilter = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.filter?.hierarchy?.conditionFilter;
};

const getSites = ({ generalFilter }) => {
    return generalFilter?.sites?.data;
};

const getSelectedAssetDetails = ({ powertrainAssetDetails }) => {
    return powertrainAssetDetails?.selectedAsset;
};

const getAllAssetsLoading = ({ overview }) => {
    return overview?.assets?.loadingStatus;
};

const getIsNavigationSearch = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.isNavigationSearch;
};

const getConditionIndicesView = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.conditionIndicesView;
};

const getHierarchyConditionIndicesLoadingStatus = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.hierarchy?.loadingStatus;
};

const getHierarchyLastUpdatedTimestamp = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.hierarchy?.data?.lastUpdatedTimestamp;
};

const getAssetsLastUpdatedTimestamp = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.assets?.data?.lastUpdatedTimestamp;
};

const getHierarchyConditionIndicesData = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.hierarchy?.data || {};
};

const getListConditionIndicesData = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.assets?.data || {};
};

export const getModel = createSelector(
    [
        getLoadingStatuses,
        getAssetNumber,
        getAssetGroupNumber,
        getAssetGroupAssetNumber,
        getPowertrainNumber,
        getPowertrainAssetNumber,
        getAssetOverviewLoadingStatus,
        getAssetGroupOverviewLoadingStatus,
        getPowertrainOverviewLoadingStatus,
        getConditionFilter,
        getAssetsConditionFilter,
        getAssetGroupsConditionFilter,
        getPowertrainsConditionFilter,
        getAssetsAssetTypeFilter,
        getAssetGroupsAssetTypeFilter,
        getPowertrainsAssetTypeFilter,
        getAssetsSubscriptionTypeFilter,
        getAssetGroupsSubscriptionTypeFilter,
        getPowertrainsSubscriptionTypeFilter,
        getSubscriptiontypes,
        getActiveTab,
        getAssetsSearchBoxFilter,
        getAssetGroupsSearchBoxFilter,
        getPowertrainsSearchBoxFilter,
        getAssetsSensorIdentifierFilter,
        getAssetGroupsSensorIdentifierFilter,
        getPowertrainsSensorIdentifierFilter,
        getSelectedFilters,
        getAllAssets,
        getSelectedOrganization,
        getFilterInProgress,
        getSelectedNotification,
        getSelectedAsset,
        getconditionIndicesV2AssetList,
        getPowertrainOverviewList,
        getAssetGroupOverviewList,
        getSites,
        getSelectedAssetDetails,
        getAllAssetsLoading,
        getIsNavigationSearch,
        getConditionIndicesView,
        getHierarchyConditionIndicesLoadingStatus,
        getHierarchySearchBoxFilter,
        getHierarchySensorIdentifierFilter,
        getHierarchySubscriptionTypeFilter,
        getHierarchyConditionFilter,
        getHierarchyAssetTypeFilter,
        getHierarchyLastUpdatedTimestamp,
        getHierarchyConditionIndicesData,
        getAssetsLastUpdatedTimestamp,
        getListConditionIndicesData
    ],
    (
        generalFilterLoadingStatuses,
        assetNumber,
        assetGroupNumber,
        assetGroupAssetNumber,
        powertrainNumber,
        powertrainAssetNumber,
        assetOverviewLoadingStatus,
        assetGroupOverviewLoadingStatus,
        powertrainOverviewLoadingStatus,
        conditionFilter,
        assetsConditionFilter,
        assetGroupsConditionFilter,
        powertrainsConditionFilter,
        assetsAssetTypeFilter,
        assetGroupsAssetTypeFilter,
        powertrainsAssetTypeFilter,
        assetsSubscriptionTypeFilter,
        assetGroupsSubscriptionTypeFilter,
        powertrainsSubscriptionTypeFilter,
        subscriptionTypes,
        activeTab,
        assetsSearchBoxFilter,
        assetGroupsSearchBoxFilter,
        powertrainsSearchBoxFilter,
        assetsSensorIdentifierFilter,
        assetGroupsSensorIdentifierFilter,
        powertrainsSensorIdentifierFilter,
        selectedFilters,
        allAssets,
        selectedOrganization,
        isFilterInProgress,
        selectedNotification,
        selectedAsset,
        conditionIndicesV2AssetList,
        conditionIndicesV2PowerTrain,
        conditionIndicesV2AssetGroups,
        sites,
        selectedAssetDetails,
        allAssetsLoadingStatus,
        isNavigationSearch,
        conditionIndicesView,
        hierarchyConditionIndicesLoadingStatus,
        hierarchySearchBoxFilter,
        hierarchySensorIdentifierFilter,
        hierarchySubscriptionTypeFilter,
        hierarchyConditionFilter,
        hierarchyAssetTypeFilter,
        hierarchyLastUpdatedTimestamp,
        hierarchyConditionIndicesData,
        assetsLastUpdatedTimestamp,
        listConditionIndicesData
    ) => {
        return {
            generalFilterLoadingStatuses,
            assetNumber,
            assetGroupNumber,
            assetGroupAssetNumber,
            powertrainNumber,
            powertrainAssetNumber,
            assetOverviewLoadingStatus,
            assetGroupOverviewLoadingStatus,
            powertrainOverviewLoadingStatus,
            conditionFilter,
            assetsConditionFilter,
            assetGroupsConditionFilter,
            powertrainsConditionFilter,
            assetsAssetTypeFilter,
            assetGroupsAssetTypeFilter,
            powertrainsAssetTypeFilter,
            assetsSubscriptionTypeFilter,
            assetGroupsSubscriptionTypeFilter,
            powertrainsSubscriptionTypeFilter,
            subscriptionTypes,
            activeTab,
            assetsSearchBoxFilter,
            assetGroupsSearchBoxFilter,
            powertrainsSearchBoxFilter,
            assetsSensorIdentifierFilter,
            assetGroupsSensorIdentifierFilter,
            powertrainsSensorIdentifierFilter,
            selectedFilters,
            allAssets,
            selectedOrganization,
            isFilterInProgress,
            selectedNotification,
            selectedAsset,
            conditionIndicesV2AssetList,
            conditionIndicesV2PowerTrain,
            conditionIndicesV2AssetGroups,
            sites,
            selectedAssetDetails,
            allAssetsLoadingStatus,
            isNavigationSearch,
            conditionIndicesView,
            hierarchyConditionIndicesLoadingStatus,
            hierarchySearchBoxFilter,
            hierarchySensorIdentifierFilter,
            hierarchySubscriptionTypeFilter,
            hierarchyConditionFilter,
            hierarchyAssetTypeFilter,
            hierarchyLastUpdatedTimestamp,
            hierarchyConditionIndicesData,
            assetsLastUpdatedTimestamp,
            listConditionIndicesData
        };
    }
);
